import React from 'react';
import { Wltp } from './wltp';
import { HeadlineComponent } from './headline';
import { StaticBackdrop } from './static-backdrop';
import { StaticImage } from './static-image';
import { CreateBoxContext } from '../utils/create-context-box';
import { useClientRect } from '../utils/use-client-rect';
import { InitialState } from '../FeatureAppTypes';

export const Static: React.FC<InitialState> = ({
  additionalText,
  themeScroll,
  animation: { headlines, fallback },
  wltp,
  themeWltp,
}: InitialState) => {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const innerRef = React.useRef<HTMLDivElement>(undefined as any);
  return (
    <>
      <CreateBoxContext.Provider value={useClientRect(innerRef)}>
        <div ref={innerRef}>
          <StaticBackdrop theme={themeScroll}>
            <HeadlineComponent isStatic headlines={headlines} theme={themeScroll} />
          </StaticBackdrop>
        </div>
        <StaticImage fallback={fallback} theme={themeScroll} />
      </CreateBoxContext.Provider>
      {wltp.length > 0 || additionalText ? (
        <Wltp wltp={wltp} additionalText={additionalText} themeWltp={themeWltp} />
      ) : undefined}
    </>
  );
};
